module.exports = __webpack_public_path__ + "static/media/IMG_0335.31268795.JPG";